import type { FC, ElementType } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { darkPrimary, lightPrimary } from 'src/colors';
import { RouteTitle } from 'src/types/enum/route-title';

interface NavbarMenuItemProps {
  active: boolean;
  href: string;
  icon: ElementType;
  onClose: () => void;
  title: RouteTitle;
}

export const NavbarMenuItem: FC<NavbarMenuItemProps> = ({
  active,
  href,
  icon: Icon,
  onClose,
  title,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { mode } = theme.palette;

  return (
    <ListItemButton
      component={RouterLink}
      divider
      onClick={onClose}
      sx={{
        alignItems: 'center',
        display: 'flex',
        backgroundColor: 'primary.contrastText',
        px: 3,
        py: 1.5,
        background: active
          ? `${
              mode === 'dark'
                ? darkPrimary.hoverOutlined
                : lightPrimary.hoverOutlined
            }64`
          : 'transparent',
        ':focus': {
          boxShadow: 'none',
          background: {
            md: active
              ? `${
                  mode === 'dark'
                    ? darkPrimary.hoverOutlined
                    : lightPrimary.hoverOutlined
                }`
              : 'transparent',
          },
        },
      }}
      target={external ? '_target' : '_self'}
      to={href}>
      <ListItemIcon
        sx={{
          color: active ? 'text.primary' : 'text.secondary',
          minWidth: 0,
          mr: 1,
        }}>
        <Icon />
      </ListItemIcon>
      <ListItemText
        primary={t(title)}
        primaryTypographyProps={{
          color: active ? 'text.primary' : 'text.secondary',
          variant: 'caption',
        }}
      />
    </ListItemButton>
  );
};
